angular.module('impactx.search').controller('SearchListLotPreSetCtrl', SearchListLotPreSetCtrl);

SearchListLotPreSetCtrl.$inject = ['OneTimeDataTransporter', 'AppConfiguration', 'ToolbarService'];

function SearchListLotPreSetCtrl (OneTimeDataTransporter, AppConfiguration, ToolbarService) {
    var self = this;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    self.lots = OneTimeDataTransporter.getData();
    self.numberOfLots = self.lots.length;
    self.trns = OneTimeDataTransporter.getTrns();

    var buttonDefinition = [];
    ToolbarService.setButtons(buttonDefinition);
}